import React from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Mixpanel from '../../shared/Mixpanel';
import { useExportData } from './hooks';

const CopyExport = ({ AdMarkupService, FlashService, creative }) => {
  const { exportContent, rtbVersion } = useExportData(
    AdMarkupService,
    creative
  );

  const handleClick = () => {
    if (rtbVersion() === '2.3') {
      FlashService.push('success', 'Pixel Url copied to clipboard');
    } else {
      FlashService.push('success', 'Ad Markup copied to clipboard');
    }

    Mixpanel.track('Copy Enhanced Ads pixel from table list');
  };

  const buttonText = () => {
    if (rtbVersion() === '2.3') {
      return 'Copy Pixel';
    } else {
      return 'Copy Ad Markup';
    }
  };

  return (
    exportContent && (
      <CopyToClipboard
        text={exportContent}
        className="enhanced-ads-table_action clickable"
      >
        <span onClick={handleClick} role="presentation" className="clickable">
          {buttonText()}
        </span>
      </CopyToClipboard>
    )
  );
};

CopyExport.propTypes = {
  AdMarkupService: PropTypes.shape({ generate: PropTypes.func }).isRequired,
  FlashService: PropTypes.shape({ push: PropTypes.func }).isRequired,
  creative: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    dsp: PropTypes.shape({
      rtb_version: PropTypes.string.isRequired
    }),
    rtb_pixel: PropTypes.shape({
      pixel_key: PropTypes.string.isRequired
    })
  }).isRequired
};

export default CopyExport;
